import React, { useCallback, useEffect, useState } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

const CheckoutDepositSearch = ({
  salonId,
  clients,
  clientsDeposits,
  fetchAllDepositClientsList,
  getAppointmentStartTimeList,
  onSelectClientDeposit,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentlyDisplayed, setCurrentlyDisplayed] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    fetchAllDepositClientsList(salonId);
  }, [fetchAllDepositClientsList, salonId]);

  const handleSearch = useCallback(
    (event) => {
      const flatClientList = clients;
      const mapDepositList = clientsDeposits.map((client) => ({
        ...client,
        user_name: flatClientList.filter((v) => v.id === client.clientId)[0]
          ? flatClientList.filter((v) => v.id === client.clientId)[0].user_name
          : '',
      }));

      const searchTerm = event.target.value.toLowerCase();
      const searchText = searchTerm.trim().replace(/^0+/, '');

      if (searchText.length > 0) {
        const searchByName = mapDepositList.filter(
          (deposit) =>
            deposit.user_name
              .trim()
              .normalize('NFD') // decompose combined graphemes
              .replace(/[\u0300-\u036f]/g, '') // gets rid of diacritics
              .replace(/^0+/, '')
              .toUpperCase()
              .indexOf(
                searchText
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase(),
              ) !== -1,
        );

        setCurrentlyDisplayed(searchByName);
        setSearchTerm(searchTerm);
      } else {
        setCurrentlyDisplayed([]);
        setSearchTerm(searchTerm);
      }
    },
    [clients, clientsDeposits],
  );

  const handleSelect = useCallback(
    (item) => {
      if (item.online_locked_on_appointments.length) {
        const IDs = item.online_locked_on_appointments.map((e) => e.appointment);
        getAppointmentStartTimeList(salonId, IDs);
      }
      onSelectClientDeposit(item);
      setCurrentlyDisplayed([]);
      setSearchTerm('');
    },
    [getAppointmentStartTimeList, onSelectClientDeposit, salonId],
  );

  return (
    <div>
      <div className="checkout-add-deposit">
        <div className="search-deposit">
          <div>
            <span>{t('checkout.depositSearch.title')}</span>
          </div>
          <div>
            <input
              type="text"
              className="input-checkout deposit"
              placeholder={t('checkout.depositSearch.inputPlaceholder')}
              value={searchTerm}
              onChange={handleSearch}
              autoComplete="off"
            />
          </div>
          <div className="dropdown-container">
            {currentlyDisplayed.length === 0 && searchTerm.length > 0 && (
              <div className="dropdown-suggestions">
                <div className="empty">{t('common.messages.noResults')}</div>
              </div>
            )}
            {currentlyDisplayed.length > 0 && searchTerm.length > 0 && (
              <div className="dropdown-suggestions">
                {currentlyDisplayed.map((client) => (
                  <div
                    className="item"
                    key={client.clientId}
                    onClick={() => handleSelect(client)}
                    role="menuitem"
                    tabIndex="0"
                  >
                    <div className="item-left"> {client.user_name} </div>
                    <div className="item-right">
                      <div className="item-sub">
                        <div>{t('checkout.depositSearch.balance')} </div>
                        <CurrencySign value={client.total} />
                      </div>
                      <div className="item-sub available">
                        <div>{t('checkout.depositSearch.available')} </div>
                        <CurrencySign value={client.available} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutDepositSearch;
